module.exports = __webpack_public_path__ + "kudos_29.svg?c88b90903d0aa0a2ed88825b8410a113";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_29.svg
// module id = 127
// module chunks = 0